import { Col, Row, Spin, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLazyGetUserInfoQuery } from '../../../redux/api/AccountApi';
import { useLazyGetBankListQuery, useLazyGetProvinceListQuery } from '../../../redux/api/SystemApi';
import OrganizationForm from './components/OrganizationForm';
import PersonalForm from './components/PersonalForm';
import '../assets/css/styles.scss'
import { BankResponse, CityResponse } from '../../common/types/types';
const { TabPane } = Tabs;

const Profile = () => {
    const [trigger, response] = useLazyGetUserInfoQuery();
    const [provinceTrigger] = useLazyGetProvinceListQuery();
    const [bankTrigger] = useLazyGetBankListQuery();
    const [provinceList, setProvinceList] = useState<CityResponse[]>([]);
    const [bankList, setBankList] = useState<BankResponse[]>([]);

    useEffect(() => {
        trigger({})
        provinceTrigger({ size: 1000, page: 0, status: 1 }).unwrap().then(res => {
            setProvinceList([...res.content].sort((a, b) => a.provinceName.localeCompare(b.provinceName)))
        })
        bankTrigger({ size: 1000, page: 0 }).unwrap().then(res => {
            setBankList([...res.content].sort((a, b) => a.bankName.localeCompare(b.bankName)))
        })
    }, [trigger, provinceTrigger, bankTrigger])

    return (
        <div style={{ padding: '20px 0px' }}>
            <div style={{ background: 'white', padding: '40px 0px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 26, color: '#D48206' }}>THÔNG TIN TÀI KHOẢN</div>
                <h3 style={{ textAlign: 'center', marginTop: 20 }}>Loại hình đăng ký</h3>
                <Row style={{ marginBottom: '5px 0px' }} align="middle" justify="center" >
                    <div
                        style={{
                            width: 100,
                            background: '#E59F17',
                            borderRadius: 10,
                            color: 'white',
                            height: 35,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                        {response.data?.roleCodes?.includes("ORGANIZATION") ? "TỔ CHỨC" : "CÁ NHÂN"}
                    </div>
                </Row>
            </div>

            <Spin spinning={!response.data || !Object.keys(response.data).length}>
                <Row align="middle" justify="center">
                    <Col span={24}>
                        {response.data?.roleCodes?.includes("ORGANIZATION") ?
                            <OrganizationForm user={response.data} provinceList={provinceList} bankList={bankList} /> :
                            <PersonalForm user={response.data} provinceList={provinceList} bankList={bankList} />
                        }
                    </Col>
                    {/* <Col span={24}>
                    <Tabs type="card" className="custom-tab">
                    <TabPane tab="CÁ NHÂN" key="1">
                    <PersonalForm />
                    </TabPane>
                    <TabPane tab="TỔ CHỨC" key="2">
                    <OrganizationForm />
                    </TabPane>
                    </Tabs>
                </Col> */}
                </Row>
            </Spin>
        </div>
    )
}

export default Profile